export default __webpack_public_path__ + "6480f5cdde16354546615db40a2888f4.png";